import { render } from "./CharacterSearchForm.vue?vue&type=template&id=616b2506"
import script from "./CharacterSearchForm.vue?vue&type=script&lang=ts"
export * from "./CharacterSearchForm.vue?vue&type=script&lang=ts"
script.render = render

export default script